import React, { useState } from 'react';

import styles from './Description.module.scss';

export interface IReadMoreItem {
  title: string;
  text: string;
}

interface IDescription {
  text: string;
  readMoreItems?: Array<IReadMoreItem>;
}

export const Description: React.VFC<IDescription> = ({ text, readMoreItems = [] }) => {
  const [isReadMoreOpen, setReadMoreOpen] = useState(false);
  return (
    <div className={styles.description}>
      <h2 className={styles.title}>Beskrivning</h2>
      <p className={styles.text}>{text}</p>
      {readMoreItems?.length ? (
        <>
          <button
            className={styles['read-more-buttons']}
            type="button"
            onClick={() => setReadMoreOpen((prev) => !prev)}
          >
            {isReadMoreOpen ? 'Läs mindre' : 'Läs mer'}
          </button>
          {isReadMoreOpen ? (
            <div className={styles['read-more-content']}>
              {readMoreItems.map((readMoreItem) => (
                <div key={readMoreItem.title}>
                  <h3 className={styles['read-more-content-title']}>{readMoreItem.title}</h3>
                  <p className={styles['read-more-content-text']}>{readMoreItem.text}</p>
                </div>
              ))}
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  );
};
